import { BaseValidator } from './base';
import { call, put, fork, select, take, takeEvery } from 'redux-saga/effects';
import { api }                from 'apps/api'
import { VALID_COMMENT }      from 'apps/action_types';
import { FSA }                from 'flux-standard-action';
import { update }             from 'apps/actions/data';
import { deepmerge }          from 'utilities/merge';
import isEmail                from 'validator/lib/isEmail';
import isEmpty                from 'validator/lib/isEmpty';
import { newDataFromDot }     from 'utilities/hash';

class CommentValidator extends BaseValidator {
  properties = [
                 'content',
               ];
  validContent(){
    let content = this.newVal.inputs.content.value;
    let isValid = this.require('content', this.messages.common.require)
    if(!isValid){
      this.newVal.error = true;
    }
  }
  validWho(){
    let inputs = this.newVal.inputs.to_whom;
    let scene = inputs.comment_scene
    this.initProperty('to_whom')
    let property = this.propertyOf('to_whom')
    if(scene === 'standard'){
      if(inputs.s.all === '0'){
        if(inputs.s.seller === '0' && inputs.s.sm === '0' && inputs.s.creator === '0'){
          this.addMessage(property, { type: 's', message: this.messages.comment.to_whom.s.required })
          this.newVal.error = true;
        }
      }
    }else if(scene === 'require_approval'){
      let isValid = false;
      if(inputs.ra.sales_manager == '1'){
        for(let user_id in inputs.sales_managers){
          if(inputs.sales_managers[user_id].checked){
            isValid = true;
            break;
          }
        }
      }else if(inputs.ra.exective == '1'){
        for(let user_id in inputs.exectives){
          if(inputs.exectives[user_id].checked){
            isValid = true;
            break;
          }
        }
      }else{
        isValid = true;
      }
      if(!isValid){
        this.addMessage(property, { type: 'ra', message: this.messages.comment.to_whom.ra.required})
        this.newVal.error = true;
      }
    }
  }
}

export const validComment = function*(){
  yield takeEvery(VALID_COMMENT, function*(action: FSA<any, any>){
    let validator;
    validator = new CommentValidator().init(action);
    let method = validator.newVal.method
    let newVal = { error: false };
    if(validator.targetIs('content')){
      validator.validContent();
    }
    if(validator.target === 'all'){
      validator.validWho();
    }
    let newData = newDataFromDot(validator.newVal, action.payload.baseScope)
    if(newData.error){
      App.store.dispatch(update(newData));
    }
    yield put(update(newData));
    validator.done();
  });
}
